export default "__VITE_ASSET__DdEN1VrA__"